export default __webpack_public_path__ + "static/media/vcollablogo.94a6386f.svg";